import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const PDFGeneratorNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const format = data.config?.format || 'A4';
  const template = data.config?.template || '';

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-red-500 to-red-600 border-2 transition-all duration-200 ${
      selected ? 'border-red-700 shadow-xl scale-105' : 'border-red-400'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentTextIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-red-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Format display */}
          <div className="flex items-center mt-1 space-x-2">
            <span className="text-xs text-red-100">
              📕 {format}
            </span>
            {template && (
              <span className="text-xs text-red-100">
                📋 Sablon
              </span>
            )}
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Template preview */}
      {template && (
        <div className="mt-2 text-xs text-red-100 bg-black bg-opacity-20 px-2 py-1 rounded truncate">
          <strong>Sablon:</strong> {template}
        </div>
      )}

      {/* Execution result */}
      {data.executionData?.pdf_url && (
        <div className="mt-2 text-xs text-red-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <strong>PDF:</strong>
          <div className="mt-1 truncate">
            <a href={data.executionData.pdf_url} target="_blank" rel="noopener noreferrer" className="underline">
              📄 Letöltés
            </a>
          </div>
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-red-700 border-2 border-white"
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-red-700 border-2 border-white"
      />
    </div>
  );
};

export default PDFGeneratorNode;
